module.exports = __webpack_public_path__ + "img/mbb-icon.99ba41d1.png";